export const SHIPPING_METHOD_SLUGS = [
  "ground",
  "2day",
  "priority-overnight",
] as const;

export type ShippingMethodSlug = (typeof SHIPPING_METHOD_SLUGS)[number];

export interface ShippingMethodOption {
  slug: ShippingMethodSlug;
  label: string;
}

export const DEFAULT_SHIPPING_METHOD_SLUG: ShippingMethodSlug = "ground";
